import { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import shallowEqual from "react-redux/es/utils/shallowEqual";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as PhonenumberPrefixesModule from "@/redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.module";
import * as PhonenumberPrefixesSelectors from "@/redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.selectors";
import * as VatPrefixModule from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.module";
import * as VatPrefixSelectors from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { CustomerFormBlockComponent } from "./customerFormBlock.component";
import { CustomerFormBlockFormValues } from "./customerFormBlock.schema";

const CustomerDetailsFormBlock = <T extends CustomerFormBlockFormValues>() => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();

    const vatPrefixes = useSelector(
        VatPrefixSelectors.getVatPrefixes,
        shallowEqual
    );

    const phonenumberPrefixes = useSelector(
        PhonenumberPrefixesSelectors.getPhonenumberPrefixes,
        shallowEqual
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (phonenumberPrefixes.length === 0) {
            dispatch(PhonenumberPrefixesModule.load());
        }
        if (vatPrefixes.length === 0) {
            dispatch(VatPrefixModule.load());
        }
    }, []);

    return (
        <Suspense fallback={<p>{t("common.loading")}</p>}>
            <CustomerFormBlockComponent<T> />
        </Suspense>
    );
};

export { CustomerDetailsFormBlock };
